import React, {TextareaHTMLAttributes, useEffect, useRef} from 'react';

type Props = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  error?: boolean;
};

const AutoResizeTextarea: React.FC<Props> = ({
  value,
  onChange,
  className = '',
  error,
  ...rest
}) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  const resize = () => {
    const el = textareaRef.current;
    if (!el) return;

    el.style.height = 'auto'; // reset
    el.style.height = `${el.scrollHeight}px`; // expand
  };

  useEffect(() => {
    resize();
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={e => {
        resize();
        onChange?.(e);
      }}
      rows={1}
      className={`w-full resize-none  overflow-hidden px-3 border rounded-lg outline-none focus:ring-1  text-sm
        ${
          error
            ? 'border-red-500 ring-red-300'
            : 'border-gray-500 ring-gray-400'
        }
        ${className}`}
      {...rest}
    />
  );
};

export default AutoResizeTextarea;
